import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { LoadingScreenService } from 'src/app/shared/components/loading-screen/loading-screen.service';
import { SearchObjectService, SearchObject } from 'src/app/shared/services/search-object.service';
import { MedicationService } from './medication.service';
import { Doses, AlternativeCoveredDrugs, TierDetails, ContentItems } from './medication.interface';
import { MatDialog } from '@angular/material/dialog';
import { TierModalComponent } from './components/tier-modal/tier-modal.component';
import { MedicationSearchFormService } from '../main/components/medication-search-form/medication-search-form.service';
import { SheetsService } from 'src/app/shared/components/sheets/sheets.service';

@Component({
  selector: 'app-medication',
  templateUrl: './medication.component.html',
  styleUrls: ['../search/search.component.scss', '../../shared/components/filter-navigation/filter-navigation.component.scss', './medication.component.scss']
})
export class MedicationComponent implements OnInit, AfterViewInit, OnDestroy {
  isIOS;
  navigationSubscription;
  clickedSearchCriteria = '';
  paramMap: any;
  showSearchToggle = false;
  searchObject: SearchObject;
  @ViewChild('scrollTopSearch', { static: false }) scrollTopSearch: ElementRef;
  doses: Doses[] = [];
  selectedDoses : Doses;
  tierDetails: TierDetails[] = [];
  alternativeCoveredDrugs: AlternativeCoveredDrugs[]  = [];
  contentItems: ContentItems;
  todayDate: Date = new Date();
  isFormularyIdCheck: boolean = false;
  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private loadingScreenService: LoadingScreenService,
    private searchObjectService: SearchObjectService,
    private medicationService: MedicationService,
    private medicationSearchFormService: MedicationSearchFormService,
    private sheetsService: SheetsService,
    public _dialog: MatDialog) {
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        this.initializeSearch();
      }
    });
    this.isIOS = (/iPad|iPhone|iPod/.test(navigator.platform) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));
  }

  ngOnInit() {

  }

  initializeSearch() {
    this.paramMap = this.activatedRoute.snapshot.queryParamMap;
    if (this.activatedRoute.snapshot.queryParamMap.keys.length > 0) {
      this.searchObjectService.setSearchObjectQuery(this.paramMap);
      this.searchObject = this.searchObjectService.getSearchObject();
      this.isFormularyIdCheck = this.searchObjectService.isFormularyIdCheck();
      if (this.searchObjectService.isValidMedicationSearchObject()) {
        this.searchDrugDetailsServices();
      } else {
        this.loadingScreenService.toggleLoaderOff();
      }
    } else {
      this.loadingScreenService.toggleLoaderOff();
    }
  }

  ngAfterViewInit() {
  }

  openChoiceFormularyTiersDialog(): void {
    if (window.innerWidth <= 768) {
      this.sheetsService.changeSheets({
        title: `${this.selectedDoses.formularyName} Prescription Tiers`,
        tierDetails: this.tierDetails,
        selectedDoses: this.selectedDoses
      });
    } else {
    const dialogRef = this._dialog.open(TierModalComponent, {
      width: (window.innerWidth > 865 ? 865 : window.innerWidth - 10) + 'px',
      data: {
        tierDetails: this.tierDetails,
        selectedDoses: this.selectedDoses
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        
      }
    });
  }
  }
  
  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  showSearch() {
    this.showSearchToggle = !this.showSearchToggle;
  }

  onOutputSearchCriteria(obj) {
    if (!this.showSearchToggle) {
      this.showSearchToggle = true;
      setTimeout(() => {
        this.scrollSearchCriteria(obj);
      }, 0);
    } else {
      this.scrollSearchCriteria(obj);
    }
  }

  scrollSearchCriteria(obj) {
    if (obj === 'all') {
      if (this.scrollTopSearch) {
        if (this.isIOS) {
          this.scrollTopSearch.nativeElement.scrollIntoView();
        } else {
          this.scrollTopSearch.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
    } else {
      this.clickedSearchCriteria = obj;
    }
    setTimeout(() => {
      this.clickedSearchCriteria = '';
    }, 200);
  }

  getToolTipTextForCovered() {
    return this.selectedDoses.drugCategory == "Brand" ? 'Brand medication' : this.selectedDoses.drugCategory == "Generic" ? 'generic medication' : '';
  }

  getToolTipTextForTier() {
    return  (this.isFormularyIdCheck ? (this.selectedDoses.tier == '1' ? 'generic': 'brand') : this.selectedDoses.tierDescription) + ' copayment';
  }

  getTextForCovered(isCovered : boolean) {
    return this.isFormularyIdCheck ? (isCovered ? 'Preferred' : 'Non-preferred') : (isCovered ? 'Covered' : 'Not Covered');
  }

  updateTierTooltip() {
    if (this.selectedDoses && this.tierDetails) {
    let tierDetails = this.tierDetails.find(td => td.tier === this.selectedDoses.tier);
    this.selectedDoses.toolTip = tierDetails && tierDetails.toolTip ? tierDetails.toolTip : '';
    this.selectedDoses.shortDescription = tierDetails ? tierDetails.shortDescription : '';
    }
  }

  updatedoses(event) {
    let selectedDose = this.doses.filter(e => e.doseId === event.target.value);
    this.selectedDoses = selectedDose.length > 0 ? selectedDose[0] : null;
    this.updateTierTooltip();
  }
  searchDrugDetailsServices() {
    this.medicationService.searchDrugDetailsServices().subscribe(response => {
      this.showSearchToggle = false;
      this.doses = response && response['doses'] ? response['doses'] : [];
      this.alternativeCoveredDrugs = response && response['alternativeDrugs'] ? response['alternativeDrugs'] : [];
      this.selectedDoses = this.doses.length > 0 ?  this.doses[0] : null;
      this.tierDetails = response && response['tierDetails'] ? response['tierDetails'] : [];
      this.contentItems =  response && response['contentItems'] ? response['contentItems'] : null;
      this.updateTierTooltip();
    })
  }

  openHoverSheet(event, title, message) {
    // sheet function
    if (!this.medicationSearchFormService.isDesktop()) {
      this.sheetsService.changeSheets({
        isMessage: true,
        title: title,
        message: message
      });
      event.stopPropagation();
    }
  }

  onClickAlternateDrug(drug: AlternativeCoveredDrugs) {
    this.searchObject.drugId = drug.drugId;
    this.searchObject.drugName = drug.drugName;
    this.searchObjectService.setSearchObject(this.searchObject);
    this.searchObjectService.setSearchURL(false, false, true);
    this.onOutputSearchCriteria('all');
  }

  isopenChoiceFormularyTiersDialog() : boolean {
    return !['0000010000010001700004', '0000010000010001700005', '0000010000010001700006', '0000010000010001700003', '0000010000010001700007'].includes(this.searchObject.networkId);
  }

  isMedicaidChc() : boolean {
    return ['0000010000010001700003', '0000010000010001700007'].includes(this.searchObject.networkId);
  }

  isChipText() : boolean {
    return ['0000010000010001700006'].includes(this.searchObject.networkId);
  }

  print() {
    window.print();
  }

}
